import { createContext } from "react";

import { Identity } from "@safetyculture/s12-apis-connect-web/s12/identity/admin/v1/identity_management_pb";

// Identity information - consumed on Identity page and children components
export type IdentityContextType = {
  identity: Identity;
  setIdentity: React.Dispatch<React.SetStateAction<Identity>>;
};

export const IdentityContext = createContext<IdentityContextType>(
  {} as IdentityContextType
);
